<template>
  <div class="title-row flex">
    <div
      v-for="(cell, index) in row"
      :key="index"
      :class="index ? 'title cell-size bg-caramel-tertiary-900' : 'cell-size'"
      class="flex flex-col relative"
    >
      <!-- badge -->
      <span v-if="cell.badge" class="badge">
        {{ $t(cell.badge) }}
      </span>
      <!-- /badge -->

      <!-- title -->
      <span v-if="cell.title" class="text-2xl font-semibold">
        {{ cell.title }}
      </span>
      <!-- /title -->
    </div>
  </div>
</template>

<script>
export default {
  props: ['row'],
}
</script>

<style src="../tailwind.css" scoped></style>
<style lang="scss" src="../styles/TitleRow.scss"></style>
